<template lang="pug">
div.bs4.trust-pilot-review-2025(:data-review-count="(data && data.total_reviews) || 0")
  div.trustpilot-main-widget.px-0.d-customize-none.modal-background(v-if="data !== null")
    .title.Black {{ __('Customer Reviews') }}
    .avg_stars_wrapper
      .avgStars {{ data.average_score }}
        div.star_image
          template(v-for="n in 5")
            img(v-if="n > data.average_score", :src="CDNPath('/img/trustpilot/star.svg')")
            img(v-else, :src="CDNPath('/img/trustpilot/star_filled.svg')")
      p {{ __('based on') }} {{ data.total_reviews }} {{ __('reviews') }}
    .review_detail
      .filter_by_rating
        p(style='font-size: 12px;order:100') {{ __('Filter by Rating') }}
        .stars_summary(v-for="n in 5", :style="{order : index}")
          span(@click="star=n") {{ n }} {{ index === 0 ? __('Star') :  __('Stars') }}
          .progress_bar(@click="star=n")
            .progress(v-if="data.stars_reviews[n]", :style="{ width: (data.stars_reviews[n])*100/data.total_reviews +'%' }")
            .progress(v-else,:style="{ width: '0%' }")
          span.count(@click="star=n") ({{ data.stars_reviews[n] || 0 }})
      .filter_by_attribute
        .level
          span {{ __('Material') }}
          div(v-for="n in 5", :class="{ first : n == 1, last : n == 5, fill : ( containsKey(data.attributes,'Materials') && n <= data.attributes.Materials ) }")
        .level
          span {{ __('Design') }}
          div(v-for="n in 5", :class="{ first : n == 1, last : n == 5, fill : ( containsKey(data.attributes,'Design') && n <= data.attributes.Design )  }")
        .level
          span {{ __('Quality') }}
          div(v-for="n in 5", :class="{ first : n == 1, last : n == 5, fill : ( containsKey(data.attributes,'Quality') && n <= data.attributes.Quality )  }")
        .level
          span {{ __('Durability') }}
          div(v-for="n in 5", :class="{ first : n == 1, last : n == 5, fill : ( containsKey(data.attributes,'Durability') && n <= data.attributes.Durability )  }")
    div.reviews
      div.filter_options_wrapper
        div.options
          div.lang(@click="show.languages = 1",v-click-outside="hideLanguage") {{ __('Language') }}
            img(class='options_arrow', :src="CDNPath('/img/trustpilot/chevron_down.svg')")
            div.option_list(v-if='show.languages')
              div(v-for='(lang,label) in languages',:value='label',@click="language = label", :class="{ selected : language == label }") {{ lang }} ({{ data.language_reviews[label] || 0 }})
          div.sort_by(@click="show.sorting = 1",v-click-outside="hideSorting")
            span {{ __('Sort By:') }} {{ __(sortings[sorting]) }}
            img(class='options_arrow', :src="CDNPath('/img/trustpilot/chevron_down.svg')")
            div.option_list(v-if='show.sorting')
              div(v-for='(sort,label) in sortings',:value='label',@click="sorting = label", :class="{ selected : sorting == label }") {{ __(sort) }}
        div.filter_row(v-if="language != '' || star != ''")
          span.filter_label {{ __('Active Filters:') }}
          div.active_filters(v-if="language != ''", v-on:click="language = ''") {{ languages[language] }}
          div.active_filters(v-if="star != ''", v-on:click="star = ''") {{ star }} Star
          div.clear_filter(v-on:click="language = ''; star = ''") {{ __('Clear All') }}

      template(v-if="data.reviews.length")
        template(v-for="review in data.reviews")
          .review
            .sidebar
              .customer_name {{ review.consumer_name }}
              .review_date {{ moment(review.createdAt).format('MM/DD/YY') }}
              .product_name {{ data.skus[review.sku] || data.skus[review.related_sku] }}
            .review_detail_content
              template(v-for="n in 5")
                img.star_image(v-if="n > review.stars", :src="CDNPath('/img/trustpilot/star.svg')")
                img.star_image(v-else, :src="CDNPath('/img/trustpilot/star_filled.svg')")
              .review_content {{ review.content }}
              //- .review_attachments(v-for="attachment in review.attachments")
              //-   template(v-for="file in attachment.processedFiles")
              //-     img(:src="file.url")
              //- .review_attachments(v-if="review.has_image === '1'")
              //-   img(:src="'/img/yotpo/square/'+review.external_id+'.png'")
              vue-preview.review_attachments(:slides="review.images")
          hr
        div.pagination
          img(:src="CDNPath('/img/trustpilot/prev.png')", @click="page > 1 ? page = page-1 : false")
          div.page(v-for="n in data.total_pages", :class="{ show: ( data.page - 2 <= n && n <= data.page + 2 ) || (data.page <= 3 && n <= 5 ) || (data.page > data.total_pages - 3 && n > data.total_pages - 5 ), active : n == data.page }", @click="page = n") {{ n }}
          img(:src="CDNPath('/img/trustpilot/next.png')", @click="page < data.total_pages ? page = page+1 : false")
      div.no-review(v-else) {{ __('No Review') }}
  div(v-else) {{ __('Loading') }}

</template>
<script>
import ClickOutside from 'vue-click-outside'
import VuePreview from 'vue-preview'

export default {

  components: {
  },

  props: ['sku', 'CDNPath'],

  name: 'trust-pilot',

  data() {
    return {
      data: null,
      language: '',
      sorting: 'photos',
      page: 1,
      star: '',
      languages: {
        'en': 'English',
        'ko': 'Korean',
        'ja': 'Japanese',
        'zh-CN': 'Chinese',
        'es': 'Spanish'
      },
      sortings: {
        'newest': 'Newest',
        'high': 'Rating: High to Low',
        'photos': 'With Photos'
      },

      show: {
        languages: 0,
        sorting: 0,
      },

      // Generic properties
      eventHub: window.vueEventHub,

      injectedMarkup: false,
    }
  },

  computed: {


  },

  watch: {
    language: function (val) {
      this.page = 1;
      this.getReviews();
      this.hideLanguage();
    },
    page: function (val) {
      this.getReviews();
    },
    sorting: function (val) {
      this.page = 1;
      this.getReviews();
      this.hideSorting();
    },
    star: function (val) {
      this.page = 1;
      this.getReviews();
    },
  },

  beforeMount() {
    this.__ = this.__ || window.__
  },

  async created() {
    this.getReviews();
    console.log('create review')

  },

  methods: {
    getReviews(callback) {
      fetch(`//${ConstantsManager.CASETAGRAM_BASE_DOMAIN_CDN}/api-cache/private/5m/Review?fn=getTrustPilotReviews&sku=` + this.sku + `&language=` + this.language + `&sorting=` + this.sorting + `&page=` + this.page + `&star=` + this.star, {
        method: 'GET',
        credentials: 'same-origin'
      })
        .then(res => res.json())
        .then(result => {
          this.data = result.data
          callback && callback(this.data)
        })
    },
    containsKey(obj, key) {
      return Object.keys(obj).includes(key);
    },
    hideLanguage() {
      this.show.languages = 0;
    },
    hideSorting() {
      this.show.sorting = 0;
    }
  },

  directives: {
    ClickOutside
  }
}
</script>

<style lang="scss">
.trust-pilot-review-2025 {
  color: #000;
  font-family: "PP Pangram Sans";
  font-size: 20px;
  font-style: normal;
  font-weight: 500;
  line-height: 120%;

  .trustpilot-main-widget {
    margin: 32px 0;
    color: black;

    hr {
      margin: 32px 0;
    }

    .title {
      color: #000;
      font-family: "PP Pangram Sans";
      font-size: 50px;
      font-style: normal;
      font-weight: 800;
      line-height: 120%;

      border-bottom: 1px solid var(--color-grey-15, #D9D9D9);
      padding: 0 32px 32px;
    }

    .avg_stars_wrapper {
      margin: 0px 32px;
      padding: 20px 0;

      p {
        color: #000;

        /* Pangram Sans Medium/20px/120% */
        font-family: "PP Pangram Sans";
        font-size: 20px;
        font-style: normal;
        font-weight: 500;
        line-height: 120%;
        /* 24px */
      }

    }

    .avgStars {
      display: flex;
      text-align: left;

      color: #000;
      font-family: "PP Pangram Sans";
      font-size: 96px;
      font-style: normal;
      font-weight: 800;
      line-height: 120%;

      .star_image {
        margin-left: 13.5px;

        img {
          height: 46px;
          display: inline-block;
          margin-left: 2.5px;
          margin-right: 2.5px;
        }
      }
    }

    .review_detail {
      display: flex;
      margin: 32px;

      .filter_by_rating {
        flex: 1;
        margin-right: 48px;
        display: flex;
        flex-direction: column-reverse;
        justify-content: flex-end;
        row-gap: 20px;

        .stars_summary {
          cursor: pointer;
          display: flex;
          // margin-top: 20px;

          .progress_bar {
            flex: 1;
            background-color: #EAEAEA;
            margin-left: 20px;
            margin-right: 20px;
            position: relative;
            border-radius: 10px;
            height: 16px;
            align-self: center;

            .progress {
              position: absolute;
              background-color: #2C5DAB;
              height: 100%;
              border-radius: 10px;
            }
          }
        }

        .count {
          font-size: 12px;
        }
      }

      .filter_by_attribute {
        flex: 1;
        margin-left: 48px;
        padding-top: 44px;
        row-gap: 20px;
        display: flex;
        flex-direction: column;

        .level {
          display: flex;

          >span {
            margin-right: 20px;
            width: 90px;
          }


          .first {
            border-radius: 100px 0px 0px 100px;
          }

          .last {
            border-radius: 0px 100px 100px 0px;
          }

          div {
            flex: 1;
            background-color: #EAEAEA;
            margin-left: 1px;
            margin-right: 1px;
            height: 16px;
            position: relative;
            align-self: center;
          }

          div.fill {
            background-color: #2C5DAB;
          }
        }
      }
    }

    .reviews {
      margin: 0;

      .filter_options_wrapper {
        display: flex;
        font-size: 16px;
        padding: 32px 32px 52px;
        row-gap: 16px;
        flex-direction: column;

        .options {
          display: flex;
          gap: 16px;

          >div {
            border: 1px solid #000;
            border-radius: 40px;
            padding: 9.5px 20px;
            display: flex;
            justify-content: space-between;
            align-items: center;
            width: 245px;
            cursor: pointer;
          }
        }

        .options_arrow {
          height: 10px;
          margin-left: 10px;
        }

        .option_list {
          border: 1px solid #B7B7B7;
          padding: 8px;
          position: absolute;
          background-color: white;
          top: 105%;
          z-index: 1;

          div {
            height: 34px;
            line-height: 34px;
            padding-left: 10px;
            padding-right: 10px;

            &:hover {
              background-color: black !important;
              color: white;
            }

            &.selected {
              background-color: #EAEAEA;
            }
          }
        }

        .lang {
          // flex: 1;
          // position: relative;
        }

        .sort_by {
          // flex: 2;
          // justify-content: right;
          // text-align: right;
          // position: relative;

          .option_list {
            right: 0;
          }
        }
      }

      .filter_row {
        display: flex;
        column-gap: 16px;
        align-items: center;

        .active_filters {
          display: inline-block;
          border-radius: 100px;
          background: var(--Color-Primitives-Gray-Scale-Black, #000);
          color: var(--Color-Primitives-Gray-Scale-White, #FFF);
          padding: 8px 16px 8px 12px;

          &::after {
            content: "";
            width: 13px;
            height: 13px;
            position: relative;
            display: inline-block;
            left: 2px;
            background-repeat: no-repeat;
            cursor: pointer;

            background-image: url(data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTciIHZpZXdCb3g9IjAgMCAxNiAxNyIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGcgaWQ9Ikdyb3VwIDI2MDkyNTIiPgo8cGF0aCBpZD0iTGluZSA1MzQgKFN0cm9rZSkiIGZpbGwtcnVsZT0iZXZlbm9kZCIgY2xpcC1ydWxlPSJldmVub2RkIiBkPSJNNC4wMDY3OCA0LjI3MzVDNC4yOTk2NyAzLjk4MDYgNC43NzQ1NCAzLjk4MDYgNS4wNjc0NCA0LjI3MzVMMTIuMDA2NyAxMS4yMTI4QzEyLjI5OTYgMTEuNTA1NyAxMi4yOTk2IDExLjk4MDYgMTIuMDA2NyAxMi4yNzM1QzExLjcxMzggMTIuNTY2NCAxMS4yMzg5IDEyLjU2NjQgMTAuOTQ2IDEyLjI3MzVMNC4wMDY3OCA1LjMzNDE2QzMuNzEzODkgNS4wNDEyNyAzLjcxMzg5IDQuNTY2MzkgNC4wMDY3OCA0LjI3MzVaIiBmaWxsPSJ3aGl0ZSIvPgo8cGF0aCBpZD0iTGluZSA1MzUgKFN0cm9rZSkiIGZpbGwtcnVsZT0iZXZlbm9kZCIgY2xpcC1ydWxlPSJldmVub2RkIiBkPSJNMTIuMTc2NyA0LjQ1NDA0QzEyLjQ2OTYgNC43NDY5NCAxMi40Njk2IDUuMjIxODEgMTIuMTc2NyA1LjUxNDcxTDUuMjM3NDYgMTIuNDU0QzQuOTQ0NTcgMTIuNzQ2OSA0LjQ2OTcgMTIuNzQ2OSA0LjE3NjgxIDEyLjQ1NEMzLjg4MzkyIDEyLjE2MTEgMy44ODM5MiAxMS42ODYzIDQuMTc2ODEgMTEuMzkzNEwxMS4xMTYxIDQuNDU0MDRDMTEuNDA4OSA0LjE2MTE1IDExLjg4MzggNC4xNjExNSAxMi4xNzY3IDQuNDU0MDRaIiBmaWxsPSJ3aGl0ZSIvPgo8L2c+Cjwvc3ZnPgo=);
          }
        }

        .clear_filter {
          display: inline-block;
          cursor: pointer;
        }
      }

      .review {
        display: flex;
        min-height: 150px;
        padding: 0 32px;
        column-gap: 108px;

        .sidebar {
          flex: 1;
          display: flex;
          flex-direction: column;
          row-gap: 16px;

          .customer_name {
            color: var(--Color-Primitives-Color-Sets-Dark-Gray-100, #8B8B8B);
          }

          .review_date {
            color: var(--Color-Primitives-Color-Sets-Dark-Gray-100, #8B8B8B);
          }

          .product_name {}
        }

        .review_content {
          margin: 32px 0;
        }

        .review_detail_content {
          flex: 4;

          .star_image {
            margin-left: 2px;
            margin-right: 2px;
            width: 32px;
          }


        }

        .review_attachments {

          .my-gallery {
            display: flex;
            flex-wrap: wrap;
            column-gap: 20px;

            figure {
              width: 230px;
              height: 300px;
            }

            figure:only-of-type {
              width: 300px;
            }

            img {
              width: 100%;
              border-radius: 32px;
              height: 100%;
              object-fit: cover;
            }
          }
        }

      }
    }

    .no-review {
      text-align: center;
      margin-bottom: 50px;
    }

    .pagination {
      display: flex !important;
      width: 300px;
      margin-left: auto !important;
      margin-right: auto !important;
      justify-content: space-between;
      flex-wrap: wrap;
      margin: 0;
      margin-top: 32px;

      img {
        cursor: pointer;
      }

      .page {
        color: #9F9F9F;
        font-size: 18px;
        cursor: pointer;
        margin-left: 5px;
        margin-right: 5px;
        display: none;

        &.show {
          display: block;
        }

        &.active {
          color: black;
        }
      }
    }
  }
}

@media (max-width: 767px) {
  .trust-pilot-review-2025 {
    font-size: 12px;

    .trustpilot-main-widget {
      margin: 20px 0;

      hr {
        margin: 20px 0;
      }

      .title {
        font-size: 26px;
        padding: 0 20px 20px;
      }

      .avg_stars_wrapper {
        margin: 0 20px;

        p {
          font-size: 12px;
        }
      }

      .avgStars {
        font-size: 36px;

        .star_image {
          margin-top: 8px;

          img {
            height: 24px;

          }
        }
      }

      .review_detail {
        display: block;
        margin: 32px 20px;

        .filter_by_rating {
          .stars_summary {
            .progress_bar {
              margin-left: 25px;
              margin-right: 8px;
            }
          }

          .count {
            width: 25px;
            text-align: right;
          }
        }

        .filter_by_attribute {
          padding-top: 32px;
        }

        .filter_by_rating,
        .filter_by_attribute {
          margin: 0px;
          row-gap: 16px;

          .level {
            // padding-bottom: 10px;

            >span {
              margin-right: 8px;
              width: 54px;
            }
          }
        }
      }

      .reviews {
        .filter_options_wrapper {
          //   display: block;
          //   justify-content: space-evenly;
          border-top: 1px solid var(--color-grey-15, #D9D9D9);
          border-bottom: 1px solid var(--color-grey-15, #D9D9D9);
          padding: 20px;
          font-size: 12px;
          margin-bottom: 20px;
          flex-direction: column;

          .options {
            >div {
              width: 165px;
              padding: 9.5px 12px;

              >span {
                text-wrap: nowrap;
              }
            }
          }

          .sort_by {
            text-align: left;
            // margin-top: 15px;

            .option_list {
              right: unset;
            }
          }

          .options_arrow {
            margin: 0;
          }
        }

        .review {
          flex-direction: column;

          .sidebar {
            row-gap: 8px;

            .review_date {
              flex: unset;
            }

            .product_name {
              margin-bottom: 8px;
            }
          }

          .review_content {
            margin: 16px 0;
          }

          .review_detail_content {
            .star_image {
              width: 10px;

              &:first-of-type {
                margin-left: 0;
              }
            }
          }

          .review_attachments {
            .my-gallery {
              column-gap: 8px;

              figure {
                width: 112px;
                height: 147px;
              }

              figure:only-of-type {
                width: 147px;
              }

              img {
                border-radius: 16px;
              }

            }
          }
        }

        .filter_row {
          column-gap: 12px;
        }
      }

      .pagination {
        margin-top: 20px;
        width: 195px;
        align-items: center;
        line-height: normal;

        .page {
          font-size: 12px;

        }
      }
    }
  }
}

// Force remove share and full screen button
.pswp__button.pswp__button--share,
.pswp__button.pswp__button--fs {
  display: none !important;
}
</style>



// WEBPACK FOOTER //
// CMSTrustPilot2025.vue?5c6a2b0e